import {Grid} from '@aboutyou/ui-components';
import React from 'react';
import styled from 'styled-components';
import {StreamPaddingCSS} from '../../../features/ProductStream/helpers';

export const WishlistItemGrid: React.FC<
  React.PropsWithChildren<{className?: string}>
> = ({children, className}) => {
  return (
    <section className={className}>
      <StyledGrid uniqueKey="wishlistItemStream" enableEnhancedTileRendering>
        {children}
      </StyledGrid>
    </section>
  );
};

const StyledGrid = styled(Grid)`
  ${StreamPaddingCSS}
`;
